<script setup>
import KdContainer from "./kdContainer.vue";

</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="145px">
      <div v-for="(sItem, index) in form.suggestionItems" :key="index">
        <div class="suggestionTitle">
          <div>{{ sItem.staffName }}</div>
        </div>
        <div>
          <el-form-item
            label="根因分析"
            :prop="`suggestionItems.${index}.reasonAnalyst`"
            :rules="rules.reasonAnalyst"
          >
            <el-input
              :disabled="sItem && sItem.reasonAnalyst !== ''"
              placeholder="请输入根因分析"
              v-model="sItem.reasonAnalyst"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>

          <el-form-item>
            <file-upload-list
              v-if="sItem && sItem.file !== ''"
              ref="fileUploadList"
              :fileList="sItem.file"
            ></file-upload-list>
            <drag-upload
              v-else
              ref="uploadFile"
              :accessoryList.sync="sItem.file"
              :httpRequest="imAction"
            />
          </el-form-item>

          <div v-if="taskDefKey == 'Activity_10n9bqm' ||
                    taskDefKey == 'Activity_0mwkwpr' ||
                    taskDefKey == 'Activity_13bppvj' ||
                    taskDefKey == 'Activity_1pp3lzj' ||
                    taskDefKey == 'Activity_0nw86wc' ||
                    taskDefKey == 'Activity_157te0n'">
            <el-form-item label="临时措施" prop="provisionalMeasures">
              <el-input v-model="sItem.provisionalMeasures" type="textarea" placeholder="请输入临时措施" disabled :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
            </el-form-item>
          </div>

<!--          <el-form-item-->
<!--            :prop="`suggestionItems.${index}.provisionalMeasuresFile`"-->
<!--          >-->
<!--            <file-upload-list-->
<!--              ref="fileUploadList"-->
<!--              :fileList="sItem.provisionalMeasuresFile"-->
<!--            ></file-upload-list>-->
<!--          </el-form-item>-->

          <el-form-item
            label="永久方案"
            :prop="`suggestionItems.${index}.permanentSolution`"
            :rules="rules.permanentSolution"
          >
            <el-input
              :disabled="sItem && sItem.permanentSolution != ''"
              placeholder="请输入永久方案"
              v-model="sItem.permanentSolution"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            :prop="`suggestionItems.${index}.permanentSolutionFile`"
          >
            <file-upload-list
              ref="fileUploadList"
              :fileList="sItem.permanentSolutionFile"
            ></file-upload-list>
          </el-form-item>
          <el-form-item
            label="计划断点时间"
            :prop="`suggestionItems.${index}.planBreakpointTime`"
            :rules="rules.planBreakpointTime"
          >
            <el-date-picker
              :disabled="sItem && sItem.planBreakpointTime != ''"
              v-model="sItem.planBreakpointTime"
              type="date"
              placeholder="请选择计划断点时间"
            >
            </el-date-picker>
          </el-form-item>
        </div>
      </div>
      <el-divider></el-divider>
      <el-form-item label="处理意见">
        <el-input
          v-model="form.handSuggestion"
          type="textarea"
          placeholder="请输入处理意见"
          :autosize="{ minRows: 4, maxRows: 4 }"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item>
        <drag-upload
          ref="uploadFile"
          :accessoryList.sync="form.handSuggestionFiles"
          :httpRequest="imAction"
        />
      </el-form-item>
      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick"
          >通过</el-button
        >
        <el-button class="lang-but" type="danger" @click="auditRejectBtClick"
          >驳回</el-button
        >
      </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog
        width="600px !important"
        title="审核驳回"
        :visible.sync="dialogVisible"
      >
        <el-form
          :model="form"
          :rules="rules"
          ref="rejectFormRef"
          label-width="140px"
        >
          <div
            class="rejectUnitInfo"
            v-for="(item, index) in form.rejectItems"
            :key="index"
          >
            <div class="delButton">
              <el-button
                v-if="index !== 0"
                type="text"
                icon="el-icon-delete"
                @click="delRejectUser(index)"
                >删除</el-button
              >
            </div>
            <el-form-item
              label="驳回责任单位人员"
              :prop="`rejectItems.${index}.userId`"
              :rules="rules.userId"
            >
              <el-select
                filterable
                clearable
                v-model="item.userId"
                placeholder="请选择驳回责任单位人员"
              >
                <el-option
                  v-for="item in userOptions.filter(
                    (optionItem) =>
                      !form.rejectItems.some(
                        (rejectItem) => rejectItem.userId === optionItem.userId
                      ) || optionItem.userId === item.userId
                  )"
                  :key="item.userId"
                  :label="item.staffName"
                  :value="item.userId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="驳回原因"
              :prop="`rejectItems.${index}.rejectReason`"
              :rules="rules.rejectReason"
            >
              <el-input
                v-model="item.rejectReason"
                type="textarea"
                placeholder="请输入驳回原因"
                :autosize="{ minRows: 4, maxRows: 4 }"
                maxlength="500"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item
            v-if="form.suggestionItems.length > form.rejectItems.length"
          >
            <el-button icon="el-icon-plus" type="text" @click="addRejectUser()"
              >新增责任单位人员</el-button
            >
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()"
              >提交</el-button
            >
            <el-button plain @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss"></style>
<script>
import { baseURL } from "../../util/url";
import { requestSubmitAuditKD } from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

/**
 * 15.2-QE确认永久方案和计划改善时间
 */
export default {
  name: "kdQeEnsurePermanentSolutionAudit",
  components: { KdAuditPassDialog },
  props: {
    taskId: String,
    questionId: String,
    taskDefKey: String,
    suggestionItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token"),
      },
      imAction: "/manage/staff/upload?fileType=auditResource",
      dialogVisible: false,
      auditPassDialogVisible: false,
      form: {
        suggestionItems: [
          {
            userId: "",
            hasReasonAnalystMaterial: "",
            reasonAnalyst: "",
            reasonAnalystMaterial: "",
            provisionalMeasures: "",
            planBreakpointTime: "",
            permanentSolution: "",
            permanentSolutionFile: [],
            // provisionalMeasuresFile: [],
            file: [],
          },
        ],
        rejectItems: [
          {
            userId: "",
            rejectReason: "",
          },
        ],
        handSuggestion: "",
        handSuggestionFiles: [],
        auditText: "",
      },
      userOptions: [],
      rules: {
        reasonAnalyst: [
          {
            required: true,
            message: "根因分析不能为空",
            trigger: ["blur", "change"],
          },
        ],
        permanentSolution: [
          {
            required: true,
            message: "永久方案不能为空",
            trigger: ["blur"],
          },
        ],
        planBreakpointTime: [
          {
            required: true,
            message: "计划断点时间不能为空",
            trigger: ["blur"],
          },
        ],
        userId: [
          {
            required: true,
            message: "驳回责任单位人员不能为空",
            trigger: ["blur", "change"],
          },
        ],
        rejectReason: [
          {
            required: true,
            message: "驳回原因不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    },
  },
  methods: {
    auditPassBtClick() {
      this.$refs["formRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        this.auditPassDialogVisible = true;
      });
    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        handlingText: this.form.handSuggestion,
        faultVideoList: this.form.handSuggestionFiles,
        variables: {
          approval: true,
        },
      };
      requestSubmitAuditKD(formData).then((res) => {
        if (res.status == "0") {
          this.$DonMessage.success("审批通过!");
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      });
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.form.rejectItems= [
        {
          userId: "",
          rejectReason: "",
        }
      ];
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      });
    },
    auditRejectSubmit() {
      this.$refs["rejectFormRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false,
          },
          rejectItems: this.form.rejectItems,
        };
        requestSubmitAuditKD(formData).then((res) => {
          if (res.status == "0") {
            this.$DonMessage.success("驳回成功!");
            this.backRouterPath();
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
    addRejectUser() {
      if (this.form.rejectItems.length > this.form.suggestionItems.length) {
        this.$DonMessage.warning("添加驳回数量超过上限！");
        return;
      }
      this.form.rejectItems.push({
        userId: "",
        rejectReason: "",
      });
    },
    delRejectUser(index) {
      this.form.rejectItems.splice(index, 1);
    },
  },
  mounted() {
    if (this.suggestionItems) {
      this.form.suggestionItems = this.suggestionItems;
      this.userOptions = this.suggestionItems;
    }
  },
};
</script>
